import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI } from '../Interface';

const ProjectTypeFields = ({ viewField }) => {
  const { values, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-1 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="salesStage"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Értékesítési szakasz" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-1 col-span-4">
        <Field
          type="text"
          name="prefix"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Prefix" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.prefix} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.prefix && values.prefix !== '' }}
        />
      </div>
    </div>
  );
};

export default ProjectTypeFields;
